import { atom } from 'jotai'
import { IRevenueAgencyDropDown } from '../types'

type IRevenueAgenciesState = Array<IRevenueAgencyDropDown> | null

const defaultState: IRevenueAgenciesState = null

// base atom with initial value
export const revenueAgenciesAtom = atom<IRevenueAgenciesState>(defaultState)